// File Metadata:
// Filename: usePersist.js
// Version: 1.00
// Created: 2022-09-28 00:13:34
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useState, useEffect } from 'react';

const usePersist = () => {
	const [persist, setPersist] = useState(JSON.parse(localStorage.getItem('persist')) || false);

	useEffect(() => {
		localStorage.setItem('persist', JSON.stringify(persist));
	}, [persist]);

	return [persist, setPersist];
};

export default usePersist;
